import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'servicedesk-widget-settings.content.embed-code.label',
		defaultMessage: 'Embed widget',
		description:
			'Label for the embed widget section containing the code to embed the widget and a copy button to copy the code displayed',
	},
	helpText: {
		id: 'servicedesk-widget-settings.content.embed-code.help-text',
		defaultMessage:
			'Copy this code onto your page to embed the widget. If you change the request type later, we’ll automatically update the widget.',
		description:
			'Help text displayed under the label and embed code box, explaining what the embed code is for',
	},
	copyCodeButtonText: {
		id: 'servicedesk-widget-settings.content.embed-code.copy-code-button-text',
		defaultMessage: 'Copy Code',
		description:
			'Text for the copy button, which when clicked copies the embed code to the clipboard.',
	},
});
